var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRecommend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 1.33334V6.66668L8.66663 4.66668L10.6666 6.66668V1.33334",
    stroke: "#4F39F6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66663 13V3.00001C2.66663 2.55798 2.84222 2.13406 3.15478 1.8215C3.46734 1.50894 3.89127 1.33334 4.33329 1.33334H12.6666C12.8434 1.33334 13.013 1.40358 13.138 1.52861C13.2631 1.65363 13.3333 1.8232 13.3333 2.00001V14C13.3333 14.1768 13.2631 14.3464 13.138 14.4714C13.013 14.5964 12.8434 14.6667 12.6666 14.6667H4.33329C3.89127 14.6667 3.46734 14.4911 3.15478 14.1785C2.84222 13.866 2.66663 13.442 2.66663 13ZM2.66663 13C2.66663 12.558 2.84222 12.1341 3.15478 11.8215C3.46734 11.5089 3.89127 11.3333 4.33329 11.3333H13.3333",
    stroke: "#4F39F6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRecommend);
export default __webpack_public_path__ + "static/media/ic_recommend.e549f3dd09cc0dd9387a176315970eb4.svg";
export { ForwardRef as ReactComponent };